import React from 'react'
import styled from 'styled-components'
import logo from '../../asset/desktop/logo.png'
import telle from '../../asset/desktop/telle.png'
import icon3 from '../../asset/desktop/icon3.png'
import twitter from '../../asset/desktop/twitter.png'
import at from '../../asset/desktop/at.png'

const index = () => {
    return (
        <Foot className = 'sm:px-10 text-white px-5'>
            <section className = 'grid grid-cols-1 sm:grid-cols-3 sm:py-20 py-10'>
                <div className = 'logo-container'>
                    <div className = 'mb-3'>
                        <img src = {logo} alt = "logo" />
                    </div>
                    <p className = 'hidden for sm:block'>DeFi for Global Health.</p>
                </div>

                <div className = 'sm:justify-self-end mb-5 sm:mb-0'>
                    <div className = 'mb-5 sm:mb-3 mt-2 sm:mt-0'>
                        <h3>Address</h3>
                        <p className = 'sm:max-w-sm font-normal'>
                            4th floor East Wing 158 Jan Smuts Building 9 Walters street, 
                            Rosebank, Gauteng, Republic of South Africa.
                        </p>
                    </div>
                    
                    <div>
                        <h3>Contact Us</h3>
                        <a href = '/' className = 'font-normal'>hello@ribbonprotocol.org</a>
                    </div>
                </div>

                <div className = 'sm:justify-self-end'>
                    <h3>Useful Links</h3>

                    <div className = 'flex mt-2'>
                        <a href = '/' className = 'mr-3'>
                            <img src = {telle} alt = "telle" />
                        </a>
                        <a href = '/' className = 'mr-3'>
                            <img src = {icon3} alt = "icon3" />
                        </a>
                        <a href = '/'>
                            <img src = {twitter} alt = "twitter" />
                        </a>
                    </div>
                </div>
            </section>

            <p className = 'pb-5'>2021 <img src = {at} alt = 'at' className = 'inline-block' /> ribbonprotocol | All Rights Reserved</p>
        </Foot>
    )
}

const Foot = styled.div`
    background: #000852;

    h3 {
        font-family: "Hind", sans-serif;
        font-weight: 700;
        font-size: 1.2em;
        margin-bottom: .3rem;
    }

    .for {
        font-family: "Hind", sans-serif;
        font-weight: 500;
    }

    p {
        font-size: 1em;
        font-weight: 400;
        font-family: "Hind", sans-serif;
    }

    a img {
        background: #00031E;
        padding: 5px;
    }

    .logo-container img {
        height: 70px;
    }

    @media screen and (max-width: 650px) {
        /* h3 {
            margin-bottom: .5rem;
        } */
    }
`

export default index
